export default "__VITE_ASSET__j5nzr5Ca__"